<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="title">The Kennedy Assassinations</h1>
<p class="subtitle">JFK and Bobby Kennedy – Debunking The Conspiracy Theories</p>
<p class="author">Mel Ayton</p>
<div class="img_container">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?482efd8c